import styled from 'styled-components'
import { InputNumber as AntInputNumber } from 'antd'

export const InputNumber = styled(AntInputNumber)`
  width: 100%;
`
